import { Component, OnInit, Input, ViewChild, TemplateRef, Output, EventEmitter, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';
import * as moment from 'moment';

import { ClientWalkInService, SubscribeService } from '../../../services/index';
import { ClientWalkInModel } from '../../../model/index';
import { clientOutComponent } from '../../common/clientOut.component';
import { TestBillGenerationComponent } from './testBillGeneration.component';

import * as fromCommonStore from '../../../store';
import * as fromRootStore from '../../../reducers';

@Component({
    selector: 'client-walk-in-tab',
    templateUrl: './clientWalkIn.component.html'
})
export class ClientWalkInComponent implements OnInit {

    isLoadMask: Promise<any>;
    clientWalkInData: ClientWalkInModel[];
    loadingIndicator: boolean = true;
    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'date',
        orderDir: 'asc'
    };
    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;
    columns = [];
    toggleCol = [];
    filterData = {
        "search_data": "",
        "from_date":new Date(),
        "to_date":new Date()
    };
    scrollTimeout: any;
    suppressPaging: boolean = false;
    userType:any;
    hasAdmin: boolean = false;

    constructor(public store: Store<fromRootStore.State>, public toasterService: ToasterService, private walkInService: ClientWalkInService, public subscribeService: SubscribeService, private modalService: BsModalService) {
        //console.log(this.gs.rootObj);
    }

    ngOnInit(): void {
        let that = this;

        // TO GET USER TYPE
        this.store.select(fromCommonStore.getAuth).subscribe((auth: any) => {
            if (auth['islogin'] && (auth['usertype'] == 'Admin' || auth['usertype'] == 'Super_Admin')) {
                this.hasAdmin = true;
            }
        });

        //page_prop -- OWN VARIABLE
        this.columns = [
            { name: 'SNo', prop: 'sno', width: 50, minWidth: 50, maxWidth: 50, sortable: false, cellClass: 'cell-center', cellTemplate: this.snoTemplate, toggle: true },
            { name: 'Date', prop: 'walikin_date', width: 100, minWidth: 100, maxWidth: 120, toggle: true, page_prop: 'Client Walk-in' },
            { name: 'Client ID', prop: 'client_no', width: 120, minWidth: 120, maxWidth: 120, page_prop: 'Client Walk-in' },
            { name: 'Name', prop: 'client_name', sortable: false, width: 180, minWidth: 180, maxWidth: 180 , page_prop: 'Client Walk-in'},
            { name: 'Status', prop: 'disp_status', sortable: false, width: 120, minWidth: 120, maxWidth: 120, cellClass: 'cell-left', page_prop: 'Status'},
            { name: 'Testing Description', prop: 'testing_description', width: 180, minWidth: 180, maxWidth: 180, page_prop: 'Phone Tracking' },
            { name: 'Trial Description', prop: 'trail_description', width: 180, minWidth: 180, maxWidth: 180, page_prop: 'Phone Tracking' },
            { name: 'Out Status', prop: 'name', sortable: false, width: 100, minWidth: 100, maxWidth: 100, cellClass: 'cell-left', page_prop: 'Phone Tracking' },
            { name: 'Reference', prop: 'reference_name', width: 200, minWidth: 200, maxWidth: 200, page_prop: 'Promo' },
            { name: 'Remarks', prop: 'description', sortable: false, width: 280, minWidth: 280, maxWidth: 280, cellClass: 'cell-left', page_prop: 'Promo' },
            { name: 'Out Status', prop: 'name', width: 150, minWidth: 150, maxWidth: 150, page_prop: 'Promo' },
            { name: 'Action', prop: 'action', sortable: false,  width: 120, minWidth: 120, maxWidth: 120, cellClass: 'cell-left', cellTemplate: this.editDeleteTemplate }
        ];
        //TO REMOVE SOME COLUMNS
        if(this['params']['tabParams'] == 'Phone Tracking'){
            var evens = _.remove(this.columns, function(obj) {
                return obj['page_prop'] == 'Phone Tracking' || obj['page_prop'] == 'Promo'
            });
        }else if(this['params']['tabParams'] == 'SG Promo' ||
            this['params']['tabParams'] == 'DR Promo' ||
            this['params']['tabParams'] == 'Store Promo' ||
            this['params']['tabParams'] == 'HV Entry' ||   this['params']['tabParams'] == 'SOA Entry') {
            var evens = _.remove(this.columns, function(obj) {
                return obj['page_prop'] == 'Phone Tracking' || obj['page_prop'] == 'Status'
            });

        }else if(this['params']['tabParams'] == 'Client Walk-in' ||	
                  this['params']['tabParams'] == 'Out-Status-Edit'){
            var evens = _.remove(this.columns, function(obj) {
                 return  obj['page_prop'] == 'Promo'
            });

        }
        this.toggleCol = Object.assign({}, this.columns);
        this.pageCallback({ offset: 0 });

        this.subscribeService.publishReloadClientWalkInGrid().subscribe(($e) => {
            that.pageCallback({ offset: 0 });
        });
    }
    ngOnDestroy() {
        // prevent memory leak when component destroyed
        //this.subscribeService.publishReloadClientWalkInGrid().unsubscribe();
    }
    onOpenedFilter(): void {
        setTimeout(function() {
            $('#filterTextBox').focus();
        }, 100);

    }

    onChangePageSize(limit) {
        this.page.limit = limit;
        this.getWalkInList();
    }

    onColumnToggle(colToShow) {
        this.columns = colToShow;
    }

    /**
    * Called whenever the user changes page
    */
    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
            this.page.offset = pageInfo.offset;
            this.getWalkInList();
        
    }
    onScroll() {
        this.suppressPaging = true;
        if (this.scrollTimeout) {
            //celarTimeout(this.scrollTimeout);
        }
        this.scrollTimeout = setTimeout(() => {
            this.suppressPaging = false;
        }, 100)
    }
    clearFilter(): void {
        this.filterData = {
            "search_data": "",
            "from_date": new Date(),
            "to_date": new Date()
        };
        this.applyFilter();
    }
    applyFilter(): void {
        //this.filterExpand = false;
        this.filterPanel.close();
        this.getWalkInList();
    }
    getWalkInList(): void {
        let params = {
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`,
            orderColumn: `${this.page.orderBy}`,
            orderDir: `${this.page.orderDir}`,
            search_data: this.filterData['search_data'],
            from_date: moment(this.filterData['from_date']).format('YYYY-MM-DD'),
            to_date: moment(this.filterData['to_date']).format('YYYY-MM-DD'),
            from_page: this['params']['tabParams']
        };
        let that = this;
        //this.store.dispatch(new commonActions.LoadAllSku(params));
        this.isLoadMask = this.walkInService
            .getWalkInList(params)
            .then(function(res: any) {
                that.loadingIndicator = false;
                that.page.count = res.totCnt;
                that.clientWalkInData = res.data;
            });
    }
    addEditClientWalkIn(mode: string, row: any): void {
        let that = this;
        setTimeout(function() {
            that.filterPanel.close();
        }, 10);

        if (mode == "Add") {
            row = {
                'walkin_id': '',
                mode: mode
            };
        } else if (mode == "Edit") {
            row['mode'] = mode;
        }
        const selectedRow = Object.assign({}, row);
        that.subscribeService.subScribeTabID('Transaction', 'AddClientWalkInComponent', selectedRow, this['params']['tabParams']);
    }
    deleteWalkIn(row: any): void {
        let that = this,
            data = {
                walkin_id: row.walkin_id
            };
        swal({
            title: 'Are you sure to Delete?',
            text: 'You will not be able to Recover this Walk-In Details of [' + row['client_no'] + '-' + row['client_name'] + ']',
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete!',
            cancelButtonText: 'No, Keep it'
        }).then(function() {
            that.isLoadMask = that.walkInService
                .deleteWalkIn(data)
                .then(function(res: any) {
                    that.loadingIndicator = false;
                    if (res.success) {
                        that.getWalkInList();
                        swal(
                            'Deleted',
                            res.message,
                            'success'
                        );
                    } else {
                        swal(
                            'ERROR',
                            res.message,
                            'error'
                        );
                    }
                });

        }, function(dismiss) {
            // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
            /*if (dismiss === 'cancel') {
              swal(
                'Cancelled',
                'Your imaginary file is safe :)',
                'error'
              )
            }*/
        })
    }
    bsModalRef: BsModalRef;
    public clientOutStaus(row: any): void {
        let that = this;
        this.bsModalRef = this.modalService.show(clientOutComponent, {
            keyboard: false,
            ignoreBackdropClick: true,
            class: 'modal-lg compWidth-75'
        });
        row['page_from'] = this['params']['tabParams'];
        row['tabParams'] = this['params']['tabParams'];
        this.bsModalRef.content.clientStatus = Object.assign({}, row);
        this.bsModalRef.content.clientOutLoadEvent.subscribe(($e) => {
            that.getWalkInList();
        });
    }

    onBillGeneration(row: any): void {
        let that = this;
        this.bsModalRef = this.modalService.show(TestBillGenerationComponent, {
            keyboard: false,
            ignoreBackdropClick: true
        });
        //row['page_from'] = 'ClientWalkIn';
        this.bsModalRef.content.clientWalkInDet = Object.assign({}, row);
        this.bsModalRef.content.walkInTestBillEvent.subscribe(($e) => {
            that.getWalkInList();
        });
    }

    onprebillclick(row: any): void {
        let that = this;
        row['mode'] = 'Add';
        row['description'] = '';
        const selectedRow = Object.assign({}, row);
        that.subscribeService.subScribeTabID('Transaction', 'AddEditSalesBillentryComponent', selectedRow, 'Advance');
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/clientWalkIn/clientWalkIn.component.ts